// src/components/WhyToBuyUs.jsx
import React, { useRef } from 'react';
import styles from '../css/modules/WhyToBuyUs.module.css';
import { useUser } from './UserContext';

const customerReviews = [
  {
    id: 1,
    name: 'Natalia Zawadzka',
    nick: 'Nata_Z',
    answered: '1101',
    review: 'Strzelasz.pl to moja tajna broń na egzamin patent strzelecki! 🔫 Zamiast wkuwać ustawę o broni i amunicji, po prostu grałam i... zapamiętałam więcej niż z ustaw i regulaminów strzelnic. Rewelacyjne podejście do nauki!',
    avatar: '/people/natalia_zawadzka.webp'
  },
  {
    id: 2,
    name: 'Kamil Rutkowski',
    nick: 'KamRUT',
    answered: '954',
    review: 'Zawsze bałem się egzaminu teoretycznego na broń, ale Strzelasz.pl to zmienił. Pytania z kodeksu karnego wchodzą jak z automatu. Cyberpunkowy klimat + konkretna wiedza = zdany egzamin!',
    avatar: '/people/kamil_rutkowski.webp'
  },
  {
    id: 3,
    name: 'Ewa Baran',
    nick: 'Baranek',
    answered: '876',
    review: 'Nigdy nie sądziłam, że nauka przepisów może być tak przyjemna. Testy są trudne, ale uczą dokładnie tego, co jest na egzaminie – ustawa o broni, kodeks karny... wszystko tam jest!',
    avatar: '/people/ewa_baran.webp'
  },
  {
    id: 4,
    name: 'Tomasz Gierszewski',
    nick: 'Gierzu',
    answered: '992',
    review: 'Strzelasz.pl to totalny sztos! Zamiast wertować ustawy, gram i uczę się przy okazji. Dzięki temu czuję się pewnie przed egzaminem na patent strzelecki. Zero nudy, maksimum efektu!',
    avatar: '/people/tomasz_gierszewski.webp'
  },
  {
    id: 5,
    name: 'Karolina Michalak',
    nick: 'Karola M.',
    answered: '972',
    review: '🚨 Super platforma! Pomogła mi ogarnąć pytania na pozwolenie na broń, które wcześniej wydawały się kompletnie nieprzyswajalne. A teraz? Nawet artykuły z ustawy cytuję z pamięci. Polecam każdemu!',
    avatar: '/people/karolina_michalak.webp'
  },
  {
    id: 6,
    name: 'Damian Nowicki',
    nick: 'Damix',
    answered: '1232',
    review: 'Jeśli ktoś myśli, że nie da się wciągnąć w naukę ustawy o broni i amunicji oraz kodeksu karnego – nie zna Strzelasz.pl. Tu się gra, uczy i zapamiętuje bez wysiłku. Najlepsze przygotowanie do egzaminu!',
    avatar: '/people/damian_nowicki.webp'
  },
  {
    id: 7,
    name: 'Zuzanna Rosiak',
    nick: 'ZuuR',
    answered: '913',
    review: 'Zaczęłam uczyć się z obowiązku, a skończyłam z pasją. Każde pytanie coś tłumaczy, nie tylko testuje. Świetna robota – wreszcie rozumiem, o co chodzi w tej całej ustawie o broni i amunicji!',
    avatar: '/people/zuzanna_rosiak.webp'
  },
  {
    id: 8,
    name: 'Marek Sienkiewicz',
    nick: 'Snajper_Marek',
    answered: '547',
    review: 'To nie jest kolejna nudna baza testów na patent strzelecki. To cyberpunkowa misja, która kończy się zdanym egzaminem! Ustawa, kodeks, definicje – wszystko wyłapane w praktyce. Polecam z całego serca.',
    avatar: '/people/marek_sienkiewicz.webp'
  },
  {
    id: 9,
    name: 'Alicja Borowska',
    nick: 'AliB',
    answered: '831',
    review: 'Strzelasz.pl to petarda! 🔥 Nie dość, że nauczyłam się do egzaminu na patent strzelecki, to jeszcze wciągnęłam się w świat przepisów karnych oraz ustawy o broni i amunicji. Nigdy nie myślałam, że artykuły kodeksu mogą być ciekawe. ZDAŁAM za pierwszym! 💪',
    avatar: '/people/alicja_borowska.webp'
  }
];

const WhyToBuyUs = () => {
  const scrollContainerRef = useRef(null);
  const { user } = useUser();

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  const hasActiveAccess =
    user &&
    user.test_access_till &&
    new Date(user.test_access_till) > new Date();
  let daysRemaining = 0;

  if (hasActiveAccess) {
    const now = new Date();
    const accessTill = new Date(user.test_access_till);
    const diffTime = accessTill - now;
    daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  return (
    <div className={styles.container}>
      <video autoPlay muted loop playsInline webkitplaysinline className={styles.backgroundVideo}
      poster="/backgrounds/shooting-001.webp">
        <source src="/backgrounds/shooting_video_small.mp4" type="video/mp4" /> 
        Twoja przeglądarka nie obsługuje odtwarzania wideo.
      </video>
      <div className={styles.overlay}></div>

      <div className={styles.content}>
        <h1 className={styles.mainHeader}>TESTY NA PATENT STRZELECKI</h1>
        <p className={styles.intro}>
          Stop nudnym testom egzaminacyjnym na broń – cyberpunkowe testy na patent strzelecki! 🚀
        </p>

        <div className={styles.reasons}>
            <h2>Dlaczego Strzelasz.pl? 🎯</h2>
            <ul className={styles.reasonList}>
              <li>💡 <strong>Aktywna nauka:</strong> Uczysz się do egzaminu strzeleckiego przez interaktywne testy w cyberpunkowym stylu.</li>
              <li>🔥 <strong>Zero nudy:</strong> Każde pytanie to jak nowa misja – wciąga i motywuje do dalszej nauki, nawet z trudnych zagadnień prawnych.</li>
              <li>⚡ <strong>Zaktualizowana baza 2025:</strong> Pytania oparte na aktualnych wymaganiach egzaminacyjnych na broń – nauka na serio, bez zgadywania.</li>
            </ul>
          </div>
        {hasActiveAccess ? (
          <div className={styles.buttonContainer} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className={styles.accessInfo} style={{ color: 'lightgrey', marginBottom: '10px' }}>
              Masz dostęp do testów jeszcze przez <strong>{daysRemaining} {daysRemaining === 1 ? 'dzień' : 'dni'}</strong>
            </div>
            <a href="/intro" className={styles.primaryButton}>
              <strong>START</strong>
            </a>
          </div>
        ) : (
          <div className={styles.buttonContainer}>
            <a href="/cennik" className={styles.primaryButton}>
              <strong>KUP DOSTĘP</strong>
            </a>
            <a href="/intro" className={styles.secondaryButton}>
              DEMO
            </a>
          </div>
        )}

        {/* Wspólny kontener dla sekcji "Korzyści" oraz "Opinie klientów" */}
        
          
          <div className={styles.reviewsSection}>
            <h2>Opinie naszych klientów, którzy zdali egzamin na broń 😃</h2>
            <div className={styles.reviewsContainer}>
              <button className={styles.arrowButton} onClick={scrollLeft}>←</button>
              <div ref={scrollContainerRef} className={styles.reviewsScroll}>
                {customerReviews.map(review => (
                  <div key={review.id} className={styles.reviewCard}>
                    <img src={review.avatar} alt={review.name} className={styles.avatar} />
                    <div className={styles.reviewContent}>
                      <h3>{review.name}</h3>
                      <h4>({review.nick})</h4>
                      <h5>Dobre odp: {review.answered}</h5>
                      <p>{review.review}</p>
                    </div>
                  </div>
                ))}
              </div>
              <button className={styles.arrowButton} onClick={scrollRight}>→</button>
            </div>
          </div>
      </div>
    </div>
  );
};

export default WhyToBuyUs;